export * from './lib/marlenka-ng-data-access.module';
export * from './lib/services/index';
